import TagManager from 'react-gtm-module';

export default function gtm(history) {
    if (!process.env.GTM_ID) {
        return;
    }

    const tagManagerArgs = {
        gtmId: process.env.GTM_ID,
    };

    TagManager.initialize(tagManagerArgs);

    history.listen((location) => {
        window.dataLayer.push({
            event: 'pageview',
            pagePath: location.pathname,
        });
    });
}
